module.exports = __webpack_public_path__ + "static/media/arrow-back.03f3bfe0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow-back.svg
// module id = 1043
// module chunks = 0